import flagsByCountryKey from '@/utils/flagsByCountryKey'

const operators = {
    equals: { key: 'equals', label: '= Equal' },
    notEqual: { key: 'notEqual', label: '≠ Not equal' },
    lessThan: { key: 'lessThan', label: '< Less than' },
    lessThanOrEqual: { key: 'lessThanOrEqual', label: '≤ Less than or equal' },
    greaterThan: { key: 'greaterThan', label: '> Greater than' },
    greaterThanOrEqual: { key: 'greaterThanOrEqual', label: '≥ Greater than or equal' },
    inRange: { key: 'inRange', label: '⊃ In range' },
    contains: { key: 'contains', label: '∈ Contains' },
    notContains: { key: 'notContains', label: '∉ Not contains' },
    startsWith: { key: 'startsWith', label: '→ Starts with' },
    endsWith: { key: 'endsWith', label: '← Ends with' },
}

export const FILTER_TYPES = {
    NUMBER: 'number',
    TEXT: 'text',
    SET: 'set',
    DATE: 'date',
}

export const OPERATORS_BY_FILTER_TYPE = {
    number: [
        operators.equals,
        operators.notEqual,
        operators.lessThan,
        operators.lessThanOrEqual,
        operators.greaterThan,
        operators.greaterThanOrEqual,
        operators.inRange,
    ],
    text: [
        operators.equals,
        operators.notEqual,
        operators.contains,
        operators.notContains,
        operators.startsWith,
        operators.endsWith,
    ],
    date: [
        operators.equals,
        operators.notEqual,
        operators.lessThan,
        operators.lessThanOrEqual,
        operators.greaterThan,
        operators.greaterThanOrEqual,
        operators.inRange,
    ],
    set: [],
}

export const getFilterTypeByFieldType = (type) => {
    const options = {
        number: FILTER_TYPES.NUMBER,
        int: FILTER_TYPES.NUMBER,
        decimal: FILTER_TYPES.NUMBER,
        string: FILTER_TYPES.TEXT,
        text: FILTER_TYPES.TEXT,
        email: FILTER_TYPES.TEXT,
        link: FILTER_TYPES.TEXT,
        select: FILTER_TYPES.SET,
        flag: FILTER_TYPES.SET,
        date: FILTER_TYPES.DATE,
        datetime: FILTER_TYPES.DATE,
    }
    return options[type]
}

const createParams = (fieldType, filter) => {
    const filterType = getFilterTypeByFieldType(fieldType)
    const isRange = filter.operator === 'inRange'
    const params = {
        number: {
            filterType,
            type: filter.operator,
            filter: filter.value,
            ...(isRange && { filterTo: filter.valueTo }),
        },
        text: {
            filterType,
            type: filter.operator,
            filter: filter.value,
        },
        date: {
            filterType,
            type: filter.operator,
            dateFrom: filter.value,
            ...(isRange && { dateTo: filter.valueTo }),
        },
        set: {
            filterType,
            values: filter.setValues,
        },
    }
    return params[filterType]
}

export const createModel = (filters, fieldType, logicalOperator) => {
    if (filters.length > 1) {
        return {
            logicalOperator,
            conditions: filters.map(filter => createParams(fieldType, filter)),
        }
    }
    return createParams(fieldType, filters[0])
}

export const FILTER_INITIAL_VALUE = {
    value: '',
    valueTo: '',
    setValues: [],
    operator: '',
}

export const createFilterFromModel = model => ({
    value: model?.filter || model?.dateFrom || FILTER_INITIAL_VALUE.value,
    valueTo: model?.filterTo || model?.dateTo || FILTER_INITIAL_VALUE.valueTo,
    setValues: model?.values || FILTER_INITIAL_VALUE.setValues,
    operator: model?.type || FILTER_INITIAL_VALUE.operator,
})

export const LOGICAL_OPERATORS = [
    { key: 'OR', label: 'Any filter' },
    { key: 'AND', label: 'All filters' },
]

export const formatFlagOptions = options => options.map((option) => {
    const { key, label } = option
    const flag = flagsByCountryKey[key] || ''
    return { key: label, label: `${flag} ${label}` }
})
